import Utils from '../../_functions/utils';
import SassVariables from './sass_variables.service.js';

function ResponsiveService($window, $rootScope, ObserverService) {

    // Regex removes all non numerical things from style definition.
    const SM_SIZE_BREAKPOINT = parseInt(SassVariables.getVariable('screenSm').replace(/[^\d.\-]/g, ''));
    const MD_SIZE_BREAKPOINT = parseInt(SassVariables.getVariable('screenMd').replace(/[^\d.\-]/g, ''));
    const LG_SIZE_BREAKPOINT = parseInt(SassVariables.getVariable('screenLg').replace(/[^\d.\-]/g, ''));

    /** Object representing supported sizes. */
    const sizes = {
        xs: 0,
        sm: SM_SIZE_BREAKPOINT,
        md: MD_SIZE_BREAKPOINT,
        lg: LG_SIZE_BREAKPOINT,
    };

    /** Service API object. */
    const responsive = this;

    /** Service helper object for additional information about screen size. */
    const state = {xs: false, sm: false, md: false, lg: false, below: {}, above: {}};

    /**
     * @description Function that must be called during the service is constructed. It assigns
     * necessary handler to the window resize event and give access to the service itself to the global scope.
     */
    responsive.initialise = () => {
        // Responsive service emits an event when breakpoint changes.
        ObserverService.makeObservable(responsive);

        onResize();
        angular.element($window).resize(onResize);

        // View object making service state inaccessible for writing from the outside.
        const readonlyView = Utils.readonlySubsetView({}, state);
        Utils.completeAssign(responsive, readonlyView);

        // Service is meant to be used in template files in most cases.
        $rootScope.responsive = readonlyView;
    };

    function onResize() {
        const width = $window.innerWidth;

        const previousState = Utils.subset(state, responsive.getSupportedSizes());

        state.xs = width < SM_SIZE_BREAKPOINT;
        state.sm = width >= SM_SIZE_BREAKPOINT && width < MD_SIZE_BREAKPOINT;
        state.md = width >= MD_SIZE_BREAKPOINT && width < LG_SIZE_BREAKPOINT;
        state.lg = width >= LG_SIZE_BREAKPOINT;

        state.below.sm = state.xs;
        state.below.md = state.xs || state.sm;
        state.below.lg = state.xs || state.sm || state.md;

        state.above.xs = state.lg || state.md || state.sm;
        state.above.sm = state.lg || state.md;
        state.above.md = state.lg;

        // Sets flag to true if any of the key field has changed.
        const hasBreakpointChanged =
            responsive.getSupportedSizes().reduce((isDifference, size) => {
                return isDifference || previousState[size] !== state[size];
            }, false);

        // Is any of breakpoints has changed signal that fact to all listeners.
        if (hasBreakpointChanged) {
            $rootScope.$apply(responsive.executeCallbacks);
        }
    }

    /**
     * @description Returns current size of the viewport.
     * @returns {String} Name of current size.
     */
    responsive.getCurrentSize = () => {
        return responsive.getSupportedSizes().find(size => state[size]);
    };

    /**
     * @description Returns supported screen size array.
     * @returns {Array} Supported breakpoints name.
     */
    responsive.getSupportedSizes = () => {
        return Object.keys(sizes);
    };

    /**
     * @description Returns supported screen sizes' data.
     * @returns {Object} Object consisting of size name and breakpoint value pairs.
     */
    responsive.getSupportedSizesData = () => {
        return angular.copy(sizes);
    };

}

/**
 * @ngdoc service
 * @name BB.Services.service:responsive
 * @requires ObserverService
 *
 * @description
 * Stores the current screen size breakpoint as well as provides global scope with handy reference to itself.
 * Listeners that are interested in screen size changes may register callback functions (see observer.service.js).
 * Screen size breakpoint is relative to iframe.
 *
 * Example: In case of size: md
 *  - xs: false
 *  - sm: false
 *  - md: true
 *  - lg: false
 *
 *  - below.xs: false
 *  - below.sm: false
 *  - below.md: false
 *  - below.lg: true
 *
 *  - above.xs: true
 *  - above.sm: true
 *  - above.md: false
 *  - above.lg: false
 *
 *  Template text modifications.
 *  <p>$root.responsive.above.md ? 'This paragraph will be shown for large screen sizes' : 'This one only for small'</p>
 *
 *  Dom manipulation. That component will be shown only for extra small screens.
 *  <component ng-if="$root.responsive.xs"></component>
 */
angular
    .module('BB')
    .service('responsive', ResponsiveService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/utility/responsive.service.js